import { routes } from '../contant';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/image/Logo.png';
import React from 'react';
const Navbar = () => {
  const navigate = useNavigate();

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 999,
        backgroundColor: 'white',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      }}
      className="flex justify-between items-center bg-white py-2 px-5 shadow-md"
    >
      {/* Logo */}
      <a
  href="https://leadgenpro.in"
  target="_blank"
  rel="noopener noreferrer"
  onClick={(e) => e.stopPropagation()} // Prevents unwanted React Router behavior
>
  <img
    src={Logo}
    style={{ width: "12rem", height: "4rem", cursor: "pointer" }}
    alt="Logo"
    className="shrink-0"
  />
</a>


      {/* Navigation Links */}
      <nav className="flex items-center space-x-6">
        <Link
          to={routes.signup}
          className="text-sm text-blue-600 hover:underline"
        >
          Signup
        </Link>
        <Link
          to={routes.signin}
          className="text-sm text-blue-600 hover:underline"
        >
          Login
        </Link>
      </nav>
    </header>
  );
};

export default Navbar;
